/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_CalendarsInputs */

const en_settings_calendars = /** @type {(inputs: Settings_CalendarsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Calendars to sync`)
};

const he_settings_calendars = /** @type {(inputs: Settings_CalendarsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`יומני גוגל לסנכרון`)
};

/**
* | output |
* | --- |
* | "Google Calendars to sync" |
*
* @param {Settings_CalendarsInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const settings_calendars = /** @type {((inputs?: Settings_CalendarsInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_CalendarsInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_calendars(inputs)
	return he_settings_calendars(inputs)
});